import {
  Paper,
  Slide,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableHead,
  TableRow,
  TableSortLabel,
} from "@material-ui/core";
import React, { useEffect } from "react";
import { usePagination, useSortBy, useTable } from "react-table";
import styled from "styled-components";
import { TableColumns } from ".";
import { useQueryContext } from "../../../context";
import { default as ResultPagination } from "./pagination";
import { default as ColumnsToggler } from "./toggler";

const StyledTable = styled(Table)`
  user-select: none;

  @media print {
    display: none;
  }
`;

const TableUI = () => {
  const {
    precatorios: data,
    orderBy,
    pagination: { perPage, totalPages, currentPage },
    setNewOrder,
  } = useQueryContext();

  const columns = TableColumns();

  const {
    allColumns,
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    state: { sortBy },
  } = useTable(
    {
      data,
      columns,
      pageCount: totalPages,
      manualPagination: true,
      manualSortBy: true,
      disableMultiSort: true,
      autoResetPage: false,
      autoResetSortBy: false,
      initialState: {
        pageIndex: currentPage - 1,
        pageSize: perPage,
        hiddenColumns: ["ordem_pagamento_ente", "credor", "devedor"],
      },
    },
    useSortBy,
    usePagination
  );

  useEffect(() => {
    if (sortBy[0] != orderBy[0]) {
      setNewOrder(sortBy);
    }
  }, [sortBy]);

  return (
    <Slide in={true} direction="up" timeout={350}>
      <Paper elevation={2}>
        <TableContainer>
          <ColumnsToggler allColumns={allColumns} />

          <StyledTable {...getTableProps()} aria-label="tabela de precatórios">
            <TableHead>
              {headerGroups.map((headerGroup) => (
                <TableRow {...headerGroup.getHeaderGroupProps()}>
                  {headerGroup.headers.map((column) => (
                    <TableCell
                      width={column.style.width}
                      {...column.getHeaderProps(column.getSortByToggleProps())}
                    >
                      {column.disableSortBy ? (
                        column.render("Header")
                      ) : (
                        <TableSortLabel
                          active={sortBy[0] && sortBy[0].id == column.id}
                          direction={
                            sortBy[0] == null
                              ? "asc"
                              : sortBy[0].desc == false
                              ? "asc"
                              : "desc"
                          }
                        >
                          {" "}
                          {column.render("Header")}{" "}
                        </TableSortLabel>
                      )}
                    </TableCell>
                  ))}
                </TableRow>
              ))}
            </TableHead>

            <TableBody {...getTableBodyProps()}>
              {page.map((row, i) => {
                prepareRow(row);

                return (
                  <React.Fragment key={i}>
                    <TableRow {...row.getRowProps()}>
                      {row.cells.map((cell) => {
                        return (
                          <TableCell key={i} {...cell.getCellProps()}>
                            {cell.render("Cell")}
                          </TableCell>
                        );
                      })}
                    </TableRow>
                  </React.Fragment>
                );
              })}
            </TableBody>

            <TableFooter>
              <TableRow>
                {data.length === 0 ? (
                  <TableCell colSpan={columns.length}>
                    Sua pesquisa não retornou nenhum resultado
                  </TableCell>
                ) : null}
              </TableRow>
            </TableFooter>
          </StyledTable>

          {totalPages > 1 && <ResultPagination colSpan={columns.length} />}
        </TableContainer>
      </Paper>
    </Slide>
  );
};

export default TableUI;
